export const NF_BANNER_TITLE= "Nintex Solution Accelerator Gallery";
export const NF_MAIN_DESC = "Sorry captain, page not found";
export const NF_BTN_CONTENT = "Home";